import { render, staticRenderFns } from "./precribe.vue?vue&type=template&id=234c6424"
import script from "./precribe.vue?vue&type=script&lang=js"
export * from "./precribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports